var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMemcycoLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 55,
    viewBox: "0 0 76 55",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0548 25.91H28.7548V31.02H47.7548V25.91H45.5048V22.22C45.4351 20.3398 44.6391 18.56 43.2843 17.2545C41.9295 15.949 40.1213 15.2196 38.2398 15.2196C36.3584 15.2196 34.5502 15.949 33.1954 17.2545C31.8406 18.56 31.0446 20.3398 30.9748 22.22L31.0548 25.91ZM33.9848 22.17C33.9566 21.5832 34.0479 20.9968 34.253 20.4463C34.4581 19.8958 34.7729 19.3927 35.1782 18.9674C35.5835 18.5422 36.071 18.2036 36.611 17.9723C37.151 17.741 37.7324 17.6217 38.3198 17.6217C38.9073 17.6217 39.4887 17.741 40.0287 17.9723C40.5687 18.2036 41.0561 18.5422 41.4615 18.9674C41.8668 19.3927 42.1815 19.8958 42.3867 20.4463C42.5918 20.9968 42.683 21.5832 42.6548 22.17V25.91H33.9848V22.17ZM28.7548 32.92H47.7548V38.03H28.7548V32.92ZM9.45484 28.07L33.2848 50.58L29.1648 54.94L0.964844 28.31L27.6048 0.12L31.9648 4.24L9.45484 28.07ZM75.5848 26.63L48.9948 54.82L44.6348 50.7L67.1448 26.87L43.3148 4.36L47.4348 0L75.5848 26.63Z",
    fill: "url(#paint0_linear_1219_389)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0548 25.91H28.7548V31.02H47.7548V25.91H45.5048V22.22C45.4351 20.3398 44.6391 18.56 43.2843 17.2545C41.9295 15.949 40.1213 15.2196 38.2398 15.2196C36.3584 15.2196 34.5502 15.949 33.1954 17.2545C31.8406 18.56 31.0446 20.3398 30.9748 22.22L31.0548 25.91ZM33.9848 22.17C33.9566 21.5832 34.0479 20.9968 34.253 20.4463C34.4581 19.8958 34.7729 19.3927 35.1782 18.9674C35.5835 18.5422 36.071 18.2036 36.611 17.9723C37.151 17.741 37.7324 17.6217 38.3198 17.6217C38.9073 17.6217 39.4887 17.741 40.0287 17.9723C40.5687 18.2036 41.0561 18.5422 41.4615 18.9674C41.8668 19.3927 42.1815 19.8958 42.3867 20.4463C42.5918 20.9968 42.683 21.5832 42.6548 22.17V25.91H33.9848V22.17ZM28.7548 32.92H47.7548V38.03H28.7548V32.92ZM9.45484 28.07L33.2848 50.58L29.1648 54.94L0.964844 28.31L27.6048 0.12L31.9648 4.24L9.45484 28.07ZM75.5848 26.63L48.9948 54.82L44.6348 50.7L67.1448 26.87L43.3148 4.36L47.4348 0L75.5848 26.63Z",
    fill: "url(#paint1_linear_1219_389)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1219_389",
    x1: 1834.98,
    y1: 1716.49,
    x2: 4767.48,
    y2: 4648.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C438C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#3F428C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#473F8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#55398A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6A3188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#842686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#A51A83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#CB0B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E6007E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E6017E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#E71D73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1219_389",
    x1: 52.549,
    y1: 43.8139,
    x2: 16.4833,
    y2: 7.65515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D70176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C438C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemcycoLogo1);
export default __webpack_public_path__ + "static/media/Memcyco_logo_1.7c9ecf93bd20f52bcff0621eb850625f.svg";
export { ForwardRef as ReactComponent };